import React from 'react';

type Props = {
  height?: number;
  type?: string;
  error?: boolean;
} & React.ComponentPropsWithRef<'input'>;

export const TextField = React.forwardRef<HTMLInputElement, Props>(
  ({ height = 42, type = 'text', error = false, ...props }, inputRef) => {
    return (
      <div className="relative w-full">
        <input
          {...props}
          type={type}
          ref={inputRef}
          style={{ height: height }}
          className={`w-full rounded border border-solid p-4 focus:outline focus:outline-2 focus:-outline-offset-2 ${
            error
              ? 'border-danger bg-danger_lighten focus:outline-danger'
              : 'border-border focus:border-primary focus:outline-primary'
          }`}
        />
      </div>
    );
  }
);

TextField.displayName = 'TextField';
